module.exports = __webpack_public_path__ + "img/sine-wave.06c23701.svg";